import type { ReactNode } from 'react';
import { Container } from 'react-bootstrap';
import { Header } from './Header';

interface AppLayoutProps {
  title: string;
  currentStep: number;
  showBack?: boolean;
  /** Set true when the page renders its own <StickyFooter> so we reserve space for it. */
  hasFooter?: boolean;
  children: ReactNode;
}

/**
 * Shared shell for every step page: fixed header (kiosk status + step
 * progress) and a centered, responsive content container. Individual pages
 * are responsible for their own <StickyFooter> so the footer content
 * (price breakdown, CTA copy) can differ per step.
 */
export function AppLayout({ title, currentStep, showBack, hasFooter = true, children }: AppLayoutProps) {
  return (
    <div className="min-vh-100 d-flex flex-column bg-surface">
      <Header title={title} currentStep={currentStep} showBack={showBack} />
      <main className={['app-main flex-grow-1', hasFooter ? 'app-main--with-footer' : ''].join(' ')}>
        <Container className="py-3 py-lg-4">{children}</Container>
      </main>
    </div>
  );
}
